export const compose = (...fns: CallableFunction[]) => (x: unknown) => {
  return fns.reduceRight((val, fn) => fn(val), x);
};

export const prop = <T = Record<string, unknown>>(key: keyof T) => (obj: T) => obj[key];

export const reverseProp = (obj: Record<string, unknown>) => (key: string) => obj[key];
